import * as paper from 'paper';
import {Point} from "paper";
import {SimpleLine, MathFunctions} from "./mathHelper";

export class DisplayFunctions {
    static PIXEL_INCH_RATE = 4;
    static INCH_DISPLAY_FRACTION = 2; // should be PIXEL_INCH_RATE for accuracy.
    static RECTWIDTH = DisplayFunctions.RoundInchToPixel(25.5);    // Standard Counter Draw Width 25.5 inches.

    static RoundPixelToInch(pixel: number) {
        return DisplayFunctions.ConvertExactPixelToInch(Math.round(pixel));
    }

    static ConvertExactPixelToInch(pixels: number) {
        return (pixels / DisplayFunctions.PIXEL_INCH_RATE);
    }

    static CeilPixelToInch(pixel: number) {
        return DisplayFunctions.customCeil(pixel / DisplayFunctions.PIXEL_INCH_RATE);
    }

    static customCeil(value: number) {
        value *= DisplayFunctions.INCH_DISPLAY_FRACTION;
        value = Math.ceil(value);
        return value / DisplayFunctions.INCH_DISPLAY_FRACTION;
    }

    static FloorPixelToInch(pixel: number) {
        pixel /= (DisplayFunctions.PIXEL_INCH_RATE / DisplayFunctions.INCH_DISPLAY_FRACTION);// (1/INCH_DISPLAY_FRACTION) inch allowed.
        pixel = Math.floor(pixel);
        pixel *= (DisplayFunctions.PIXEL_INCH_RATE / DisplayFunctions.INCH_DISPLAY_FRACTION);
        return pixel / DisplayFunctions.PIXEL_INCH_RATE;
    }

    static ConvertExactInchToPixel(inches: number) {
        return (inches * DisplayFunctions.PIXEL_INCH_RATE);
    }

    static customRound(value: number, fractionAccuracy?: number) {
        if (!fractionAccuracy) {
            fractionAccuracy = DisplayFunctions.INCH_DISPLAY_FRACTION;
        }
        value *= fractionAccuracy;
        value = Math.round(value);
        return value / fractionAccuracy;
    }

    static RoundInchToPixel(inch: number) {
        return Math.round(inch * DisplayFunctions.PIXEL_INCH_RATE);
    }

    static setMaxDeltaByOppositeSide(segment: any, delta: paper.Point): paper.Point | null {
        var seg = segment;
        var myLine: any, pairedLine: any;
        var swap = false;
        myLine = new SimpleLine(seg.point, seg.next.point);
        pairedLine = new SimpleLine(seg.pairedCurve.point, seg.pairedCurve.next.point);
        if (!seg.data.crossSectionGroup && seg.pairedCurve.data.crossSectionGroup) {
            seg = seg.pairedCurve;
            swap = true;
        } else if (MathFunctions.getLineLength(pairedLine) < MathFunctions.getLineLength(myLine)) {
            swap = true;
        }
        if (swap) {
            swap = myLine;
            myLine = pairedLine;
            pairedLine = swap;
            delta = MathFunctions.reverseVector(delta);
        }
        var interceptVector = MathFunctions.getLineNormal(myLine);
        var interceptLine = new SimpleLine(MathFunctions.getLineMidpoint(myLine), MathFunctions.addVectors(MathFunctions.getLineMidpoint(myLine), interceptVector));
        var interceptPoint = MathFunctions.getInterceptBetweenSimpleLines(pairedLine, interceptLine);
        interceptLine.point2 = interceptPoint;

        var curLength = MathFunctions.getLineLength(interceptLine);//RoundInchToPixel(Number(crossSectionPT.content));
        interceptVector = MathFunctions.getLineVector(interceptLine);
        if (Math.ceil(delta.length) >= (curLength - (DisplayFunctions.PIXEL_INCH_RATE / 2)) && MathFunctions.getScalarLengthAlong(delta, interceptVector) >= 0) { //shrinking (towards opp line) && too far.
            var deltaLength = curLength - (DisplayFunctions.PIXEL_INCH_RATE / 2); //leave 1/2 inch.
            if (deltaLength <= (DisplayFunctions.PIXEL_INCH_RATE / 2)) {
                return null;
            }
            delta = delta.normalize(deltaLength);
        }
        return (swap) ? MathFunctions.reverseVector(delta) : delta;
    }

}
